import React, { useState } from 'react';
import ApiAcademias from '../services/academiaService';
import Swal from 'sweetalert2';
//import ReCAPTCHA from 'react-google-recaptcha';
//import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default function ContatoFormulario() {
    const [showForm, setShowForm] = useState(true);
    const [razaoSocial, setRazaoSocial] = useState('');
    const [contatoEmail, setContatoEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [tipoDeVinculacao, setTipoDeVinculacao] = useState('');
    const [image, setImage] = useState('');
    const [oficioRequerendo, setOficioRequerendo] = useState('');
    const [copiaCnpj, setCopiaCnpj] = useState('');
    const [alvara, setAlvara] = useState('');

    const handleFileChange = (e, setFileState) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const response ={'media_url': e.target.result, 'media_from':'file_upload', 'name':file.name};
            setFileState(response, URL.createObjectURL(file));
        };
        reader.readAsDataURL(file);
    }

    const formatCnpj = (value) => {
    return value
        .replace(/\D/g, '') // remove tudo que não for número
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .slice(0, 18); // limita tamanho
};

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            razao_social: razaoSocial,
            contato_email: contatoEmail,
            senha: senha,
            tipo_de_vinculacao: tipoDeVinculacao,
            cnpj: cnpj,
            foto: image,
            sobre: razaoSocial,
            anexo: [oficioRequerendo, copiaCnpj, alvara],
        };

        try {
            const response = await ApiAcademias.cadastrar(data);
            if (response.status === 'success') {
                setShowForm(false);
                Swal.fire({
                  title: 'Sucesso!',
                  text: 'Recebemos seus dados com sucesso, aguarde novidades através do email cadastrado!',
                  icon: 'success',
                  confirmButtonText: 'Ok'
                })
            } else {
                Swal.fire({
                  title: 'Houve um erro ao cadastrar a academia!',
                  text: response.message,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
            }
        } catch (error) {
            Swal.fire({
                title: 'Houve um erro ao cadastrar a academia!',
                text: error,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-10 offset-lg-1">
                    <div className="contact_form_wrapper">
                        {!showForm &&
                            <h3>Recebemos seus dados com sucesso, aguarde novidades através do email cadastrado!</h3>
                        }
                        {showForm &&
                            <form
                                name="contactForm"
                                id="contact_form"
                                className="form-border"
                                onSubmit={handleSubmit}
                            >
                                <div className="row">
                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Academia</span>
                                        <input
                                            required
                                            type="text"
                                            name="razao_social"
                                            className="form-control"
                                            placeholder="Razão Social"
                                            onChange={(event) => setRazaoSocial(event.target.value)}
                                        />
                                    </div>
                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">CNPJ</span>
                                        <input
                                            required
                                            type="text"
                                            name="cnpj"
                                            className="form-control"
                                            placeholder="CNPJ"
                                            onChange={(event) => setCnpj(formatCnpj(event.target.value))}
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Email</span>
                                        <input
                                            required
                                            type="email"
                                            name="Email"
                                            className="form-control"
                                            placeholder="Seu Email"
                                            onChange={(event) => setContatoEmail(event.target.value)}
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Senha</span>
                                        <input
                                            required
                                            type="password"
                                            name="senha"
                                            className="form-control"
                                            placeholder="Sua Senha"
                                            onChange={(event) => setSenha(event.target.value)}
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Seleciono o tipo de cadastro</span>
                                        <select
                                            required
                                            name="tipo_de_vinculacao"
                                            className="form-control"
                                            onChange={(event) => setTipoDeVinculacao(event.target.value)}
                                        >
                                            <option value="">:: Selecione ::</option>
                                            <option value="Filiação">Filiação</option>
                                            <option value="Vinculação">Vinculação</option>
                                        </select>
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Logomarca</span>
                                        <input
                                            required
                                            type="file"
                                            onChange={(event) => handleFileChange(event, setImage)}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Ofício de Requerendo</span>
                                        <input
                                            required
                                            type="file"
                                            onChange={(event) => handleFileChange(event, setOficioRequerendo)}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Cópia do CNPJ</span>
                                        <input
                                            required
                                            type="file"
                                            onChange={(event) => handleFileChange(event, setCopiaCnpj)}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Alvará de Funcionamento e Localização</span>
                                        <input
                                            required
                                            type="file"
                                            onChange={(event) => handleFileChange(event, setAlvara)}
                                            className="form-control"
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    {/* <ReCAPTCHA
                                        sitekey=""
                                        onChange={handleRecaptcha}
                                    /> */}
                                    <div id="submit" className="mt30">
                                        <button type="submit" id="send_message" className="btn-main">
                                            Enviar Solicitação de Cadastro
                                        </button>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
